// {{token}} substitution on the public form — the thank-you page's message,
// and the terms shown above a signature pad. A DISPLAY convenience: what is
// recorded at signing is rendered again on the server with the submission's
// own values, and that copy is the one that counts.
//
// Only flat `{{key}}` here, and a token the answers do not have is LEFT AS
// WRITTEN: this is somebody's contract wording, and a silently blanked clause
// is worse than a visible placeholder. (The thank-you page keeps its own
// filler, which blanks unknown tokens — it also builds redirect URLs, where a
// literal {{token}} would be the worse outcome.) The delivery template
// language's blocks ({{#each}}, {{#if}}) are the server's; on the form they
// too are left as written.

/** Composite answers (name, address) are shown by their full form. */
function textOf(v: unknown): string {
  if (v === null || v === undefined) return '';
  if (Array.isArray(v)) return v.map(textOf).filter(Boolean).join(', ');
  if (typeof v === 'object') {
    const o = v as Record<string, unknown>;
    const full = o.fullName ?? o.fullAddress;
    return typeof full === 'string' ? full : Object.values(o).map(textOf).filter(Boolean).join(', ');
  }
  return String(v);
}

export function fillTokens(tpl: string, values: Record<string, unknown>): string {
  return tpl.replace(/\{\{\s*([A-Za-z0-9_.-]+)\s*\}\}/g, (whole, key: string) =>
    (key in values ? textOf(values[key]) : whole));
}
